var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import HeaderText from './InitialTitle';
var InformationColumn = function (_a) {
    var activeContentItem = _a.activeContentItem, mainTitleText = _a.mainTitleText, leftColumnRef = _a.leftColumnRef, nativeLeftTitleRef = _a.nativeLeftTitleRef, _b = _a.textTitleColorClass, textTitleColorClass = _b === void 0 ? 'text-enblue-900' : _b;
    var isTitleActive = useMemo(function () { return activeContentItem === null; }, [activeContentItem]);
    return (_jsx("div", __assign({ className: "jobs__column jobs__column__title block w-full", ref: leftColumnRef }, { children: _jsx(HeaderText, { textTitleColorClass: textTitleColorClass, nativeLeftTitleRef: nativeLeftTitleRef, mainTitleText: mainTitleText }, void 0) }), void 0));
};
export default InformationColumn;
